import React from 'react';
import { Link } from 'react-router-dom';

const TextLink = ({ id, textLink, path }) => <Link to={`${path}/${id}`}>{textLink}</Link>;

export default TextLink;
